var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[(_vm.$route.params.id == 'legal-notice')?_c('LegalNotice'):_vm._e(),(_vm.$route.params.id == 'terms-of-use')?_c('TermsOfUse'):_vm._e(),(_vm.$route.params.id == 'privacy-policy')?_c('PrivacyPolicy'):_vm._e(),(_vm.$route.params.id == 'cookie-policy')?_c('CookiePolicy'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }